import { render } from "./AmountInput.vue?vue&type=template&id=2b093182&scoped=true"
import script from "./AmountInput.vue?vue&type=script&lang=js"
export * from "./AmountInput.vue?vue&type=script&lang=js"

import "./AmountInput.vue?vue&type=style&index=0&id=2b093182&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b093182"]])

export default __exports__